import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.scss";
import ProfileCard from "./ProfileCard/ProfileCard";
import ThemeToggle from "../ThemeToggle/ThemeToggle";
import FloatingManualButton from "./FloatingManualButton/FloatingManualButton";
import { EmailIcon, PhoneIcon } from "../../assets/icons";
import { getMe } from "../../api";
import { useAppContext } from "../Context/AppContext";
import config from "../../config";
import { useThemedAssets } from "../../helpers/themeAssets";

function Header() {
  const { setUserProfile, userProfile } = useAppContext();
  const { logoFull, logoMobile } = useThemedAssets();
  const [linkClicked, setLinkClicked] = useState(false);
  const currentURL = useLocation();
  const navigate = useNavigate();
  const { appVersion } = useAppContext();
  const unProtectedRoutes = useMemo(() => [
    "/signin",
    "/",
    "/resetpassword",
    "/selectorganization"
  ], []);

  const fetchUserProfile = useCallback(
    async (data) => {
      // Check if user is authenticated before making API call
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        if (!unProtectedRoutes.includes(currentURL.pathname)) {
          navigate("/signin");
        }
        return;
      }

      // Only fetch user profile if we're on a protected route
      if (!unProtectedRoutes.includes(currentURL.pathname)) {
        try {
          const user = await getMe();
          setUserProfile(user);
        } catch (error) {
          console.log("getMe error -->>>", error);
          console.log("currentURL.pathname -->>>", currentURL.pathname);
          navigate("/signin");
        }
      }
    },
    [currentURL.pathname, navigate, setUserProfile, unProtectedRoutes]
  );


  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile, currentURL.pathname]);

  function handleNavLinkClick(e) {
    const navOptionName = e.target.name;
    localStorage.removeItem("cbcValue");
    localStorage.removeItem("AREA_SCAVO");
    setLinkClicked(navOptionName);
  }

  return (
    <header className="header">
      {unProtectedRoutes.includes(currentURL.pathname) ? (
        <>
          <div className="logo-container">
            <img
              className="mobile-view-logo"
              src={logoMobile}
              alt="Logo Archeo"
            />
            <img
              className="desktop-view-logo"
              src={logoFull}
              alt="Logo Archeo"
            />

            {/*
            <LogoIcon className="desktop-view-logo" />
            <LogoIcon className="mobile-view-logo" mobileView={true} />
            <div className="logo-text">
              <h1 className="logo-title">SISTEMA INFORMATIVO SIBARI</h1>
              <h2 className="logo-subtitle">
                ARCHEO: Gestione Dati Archeologici
              </h2>
            </div>
            */}
          </div>
          <div className="info-container">
            <div className="contact-info">

              <div className="email-container">
                <EmailIcon fillColor="var(--archeo-color)" />
                <span className="email">{config.supportEmail}</span>
              </div>
              <div className="phone-container">
                <PhoneIcon fillColor="var(--archeo-color)" />
                <span className="phone">{config.supportPhone}</span>
              </div>

            </div>
            <div className="header-meta-block">
              <ThemeToggle />
              <span className="version">ARCHEO v.{appVersion}</span>
            </div>
          </div>
        </>
      ) : (
        <>
          {" "}
          <div className="logo-container">
            <Link to="/home" name="homepage">
              <img
                className="mobile-view-logo"
                src={logoMobile}
                alt="Logo Archeo"
              />
              <img
                className="desktop-view-logo"
                src={logoFull}
                alt="Logo Archeo"
              />
            </Link>

            {/*}
            <LogoIcon className="desktop-view-logo" />
            <div className="logo-text">
              <h1 className="logo-title">SISTEMA INFORMATIVO SIBARI</h1>
              <h2 className="logo-subtitle">
                ARCHEO: Gestione Dati Archeologici
              </h2>
            </div>
            */}
          </div>
          <nav className="navigation">
            {/*<LogoIcon className="mobile-view-logo" mobileView /> */}
            <Link
              onClick={handleNavLinkClick}
              name="homepage"
              to="/Mapview"
              className={`nav-link ${
                (linkClicked === "homepage" ||
                  currentURL.pathname === "/Mapview") &&
                "active"
              }`}
            >
              Web GIS
            </Link>
            <Link
              onClick={(e) => {
                handleNavLinkClick(e);
              }}
              name="dati"
              to="/Reperti"
              className={`nav-link ${
                (linkClicked === "dati" ||
                  currentURL.pathname === "/Reperti") &&
                "active"
              }`}
            >
              Archivio Dati
            </Link>
            {/* <Link
              onClick={(e) => {
                handleNavLinkClick(e); 
                
              }}
              name="manuale"
              to="/manualeutente"
              className={`nav-link ${
                (linkClicked === "manuale" || currentURL.pathname === "/manualeutente") &&
                "active"
              }`}
              
            >
              Guida Utente
            </Link> */}
            <ThemeToggle />
            <ProfileCard user={userProfile} />
          </nav>
        </>
      )}
      <FloatingManualButton
        currentPath={currentURL.pathname}
        isActive={
          linkClicked === "manuale" ||
          currentURL.pathname === "/manualeutente"
        }
        onNavClick={handleNavLinkClick}
      />
    </header>
  );
}

export default Header;
